<app-sortable-section-desktop-tablet
  [showTitle]="true"
  [sectionTitle]="sectionTitle"
  [sectionHeaders]="sectionHeaders"
  [selectedHeader]="selectedHeader"
  [hasSectionData]="lists?.length === 0 ? false : true"
  [noDataText]="'i18n.lists.noListsToShow' | translate"
  (updateSortEventEmitter)="updateListOfListsSort($event)"
>
  <ng-container *ngFor="let list of lists; index as i; trackBy: trackItem">
    <div *ngIf="list?.listKey?.listTypeId === 'AI'" class="in-progress-banner">
      <ion-icon name="sparkles-outline"></ion-icon>
      {{ 'i18n.lists.aiListPage.listInProgress' | translate }}
    </div>
    <ion-row
      [attr.data-cy]="'list-data-row-' + i"
      class="sortable-section-data-row"
      (click)="
        openListDetails(
          $event,
          [
            'lists',
            'detail',
            list?.listKey?.listTypeId + '-' + list?.listKey?.listId,
          ],
          list?.listName,
          list?.aiListId
        )
      "
    >
      <!-- List Name -->
      <ion-col
        [attr.data-cy]="'list-data-list-name-column-' + i"
        size="4.05"
        offset="0.25"
      >
        <p [attr.data-cy]="'list-data-list-name-text-' + i">
          {{
            list?.listKey?.listTypeId.toUpperCase() === 'OG'
              ? ('i18n.lists.orderGuide' | translate) +
                ' #' +
                list?.listKey?.listId
              : list?.listName
          }}
        </p>
      </ion-col>
      <!-- Last Updated By -->
      <ion-col
        [attr.data-cy]="'list-data-last-updated-by-column-' + i"
        size="3"
        offset="0.15"
      >
        <!-- First and Last Name -->
        <p
          *ngIf="
            list?.updatedByUser?.firstName || list?.updatedByUser?.lastName
          "
          [attr.data-cy]="'list-data-last-updated-by-user-info-text-' + i"
          class="list-data-last-updated-by-text"
        >
          <ng-container
            *ngIf="
              list?.updatedByUser?.firstName !== list?.updatedByUser?.lastName;
              else sameFirstAndLast
            "
          >
            {{ list?.updatedByUser?.firstName }}&nbsp;{{
              list?.updatedByUser?.lastName
            }}
          </ng-container>
          <ng-template #sameFirstAndLast>
            {{ list?.updatedByUser?.firstName }}
          </ng-template>
        </p>
        <!-- System -->
        <p
          *ngIf="
            !(list?.updatedByUser?.firstName || list?.updatedByUser?.lastName)
          "
          [attr.data-cy]="'list-data-last-updated-by-user-info-text-' + i"
          class="list-data-last-updated-by-text"
        >
          {{ 'i18n.common.system' | translate }}
        </p>
        <!-- Username-->
        <p
          *ngIf="list?.updatedByUser?.userName"
          [attr.data-cy]="'list-data-last-updated-by-user-name-text-' + i"
          class="list-data-last-updated-by-text"
        >
          ({{ list?.updatedByUser?.userName }})
        </p>
      </ion-col>
      <!-- Products -->
      <ion-col
        [attr.data-cy]="'list-data-products-column-' + i"
        size="1.75"
        offset="0.15"
      >
        <div
          *ngIf="
            list?.listKey?.listTypeId.toUpperCase() !== 'ML' ||
            (list?.listKey?.listTypeId.toUpperCase() === 'ML' &&
              masterListItemsAreLoaded)
          "
          [attr.data-cy]="'list-data-products-section-' + i"
          class="green-badge"
        >
          <ion-badge [attr.data-cy]="'list-data-products-icon-' + i" mode="ios">
            {{ list?.listItemCount || 0 }}
          </ion-badge>
        </div>
        <div
          *ngIf="
            list?.listKey?.listTypeId.toUpperCase() === 'ML' &&
            !masterListItemsAreLoaded
          "
        >
          <ion-spinner name="circles"></ion-spinner>
        </div>
      </ion-col>
      <!-- Discontinued -->
      <ion-col
        [attr.data-cy]="'list-data-discontinued-column-' + i"
        size="1.75"
        offset="0.15"
      >
        <div
          *ngIf="list?.discontinuedCount > 0"
          [attr.data-cy]="'list-data-discontinued-section-' + i"
          class="red-badge"
        >
          <ion-badge
            [attr.data-cy]="'list-data-discontinued-icon-' + i"
            mode="ios"
          >
            {{ list?.discontinuedCount }}
          </ion-badge>
        </div>
        <div *ngIf="list?.listKey?.listTypeId === 'AI'">
          {{ 'i18n.common.notApplicable' | translate }}
        </div>
      </ion-col>
      <!-- List Options -->
      <ion-col
        [attr.data-cy]="'list-data-list-options-column-' + i"
        size="0.5"
        offset="0.25"
      >
        <div [attr.data-cy]="'list-data-list-options-section-' + i">
          <ion-icon
            *ngIf="list?.showEllipsis"
            [attr.data-cy]="'list-data-list-options-icon-' + i"
            name="ellipsis-vertical"
            size="small"
            slot="end"
            (click)="
              openListOptions(
                $event,
                [
                  'lists',
                  'management',
                  list?.listKey?.listTypeId + '-' + list?.listKey?.listId,
                ],
                list,
                list?.listName,
                list?.listKey?.listTypeId,
                list?.downloadPrintFlag
              )
            "
          ></ion-icon>
        </div>
      </ion-col>
    </ion-row>
  </ng-container>
</app-sortable-section-desktop-tablet>
